/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

const MODAL_SELECTOR = '.modal-overlay';
const subscribers = new Set<() => void>();
let observer: MutationObserver | null = null;
let observedTopmost: Element | null = null;

function topmostModal(document: Document): Element | null {
  const overlays = document.querySelectorAll(MODAL_SELECTOR);
  return overlays.item(overlays.length - 1);
}

/** A table inside the active modal keeps its own row tools; covered tables do not. */
export function isDataTableBlockedByModal(table: Element | null): boolean {
  if (!table) return true;
  const modal = topmostModal(table.ownerDocument);
  return Boolean(modal && !modal.contains(table));
}

function changedNodeContainsModal(node: Node): boolean {
  if (node.nodeType !== 1) return false;
  const element = node as Element;
  // SVG edges and text mutations cannot introduce the shared HTML modal surface.
  if (element.namespaceURI !== 'http://www.w3.org/1999/xhtml') return false;
  return element.matches(MODAL_SELECTOR) || Boolean(element.querySelector(MODAL_SELECTOR));
}

/** One observer for all tables; ordinary table/graph updates never notify consumers. */
export function subscribeToDataTableModalBoundary(onChange: () => void): () => void {
  if (typeof document === 'undefined' || typeof MutationObserver === 'undefined') return () => undefined;
  subscribers.add(onChange);
  if (!observer) {
    observedTopmost = topmostModal(document);
    observer = new MutationObserver((records) => {
      const modalChanged = records.some((record) => (
        [...record.addedNodes, ...record.removedNodes].some(changedNodeContainsModal)
      ));
      if (!modalChanged) return;
      const next = topmostModal(document);
      if (next === observedTopmost) return;
      observedTopmost = next;
      subscribers.forEach((subscriber) => subscriber());
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  return () => {
    subscribers.delete(onChange);
    if (subscribers.size === 0) {
      observer?.disconnect();
      observer = null;
      observedTopmost = null;
    }
  };
}
